<div class="dialog-container">
    <div class="dialog-header">
        <!-- Display year range like "25-26" -->
        <h2>जाहिरात विभाग - वर्ष {{ selectedYearRange }} करिता उद्दिष्ट - पूर्तता</h2>
    </div>

    <div class="dialog-content">
        <span class="loader" *ngIf="isLoading"></span>


        <div *ngIf="!isLoading && representativeSummaries.length > 0" class="report-wrapper print-section"
            id="business-report-table">
            <table class="ledger-table">
                <thead>
                    <tr>
                        <th rowspan="2">अ.क्र.</th>
                        <th rowspan="2">कार्यालयीन प्रतिनिधी</th>
                        <th colspan="3">चालू वर्षाचा आज अखेर पूर्ण व्यवसाय</th>
                        <!-- <th rowspan="2">एकूण व्यवसाय</th> -->
                        <!-- <th rowspan="2">टक्के</th> -->
                        <th colspan="3">जमा रक्कम</th>
                        <th colspan="3">येणे बाकी</th>
                    </tr>
                    <tr>
                        <th>दिलेले उद्दिष्ट</th>
                        <th>झालेला व्यवसाय</th>
                        <th>टक्के</th>

                        <th>जाहिरात</th>
                        <th>देणगी/अन्य</th>
                        <th>एकूण जमा</th>

                        <th style="text-align: end;">{{ oldOutstandingHeader }}</th>
                        <th>{{ currentPeriodHeader }}</th>
                        <th>एकूण येणे बाकी</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let rep of representativeSummaries; let i = index"
                        [style.background-color]="getRowColor(i)">
                        <td class="serial-cell">{{ i + 1 }}</td>
                        <td class="rep-name-cell" style="text-align: left;">{{ rep.off_rep_name }}</td>


                        <td class="amount-cell" style="text-align: end;">
                            <input type="number" style="text-align: end; width: 100%;" [(ngModel)]="rep.target"
                                (ngModelChange)="calculateMetrics(rep)" class="target-input">
                        </td>


                        <!-- <td class="amount-cell" style="text-align: end;">{{ formatCurrency(rep.total) }}</td>

                        <td class="amount-cell" style="text-align: end;">{{ rep.currentPercentage }}%</td> -->

                        <td class="amount-cell" style="text-align: end;"><strong>{{ formatCurrency(rep.total)
                                }}</strong></td>

                        <td class="amount-cell" style="text-align: end;">{{ calculateTotalPercentage(rep) }}%</td>

                        <td class="amount-cell" style="text-align: end;">{{ formatCurrency(rep.rcv_total) }}</td>

                        <td class="amount-cell" style="text-align: end;">{{ formatCurrency(rep.donation_amt) }}</td>
                        <td class="month-total-cell" style="text-align: end;">
                            {{ formatCurrency(getEkunJama(rep)) }}
                        </td>

                        <td class="amount-cell" style="text-align: end;">{{ formatCurrency(rep.old_outstanding) }}</td>
                        <td class="amount-cell" style="text-align: end;">{{ formatCurrency(rep.current_period_unpaid) }}
                        </td>
                        <td class="grand-total-cell" style="text-align: end;">{{ formatCurrency(rep.total_unpaid) }}
                        </td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr class="total-row" style="background-color: aqua;text-align: end;">
                        <td colspan="2" style="background-color: aqua;text-align: end;">एकूण</td>
                        <td class="amount-cell" style="text-align: end;">{{ formatCurrency(getTotalTarget()) }}</td>

                        <!-- <td class="amount-cell" style="text-align: end;">{{ formatCurrency(calculateGrandTotal()) }}</td>
                        
                        <td>-</td> -->

                        <td class="amount-cell" style="text-align: end;"><strong>{{
                                formatCurrency(calculateGrandTotal()) }}</strong></td>

                        <!-- Replace the टक्के dash in tfoot -->
                        <td class="amount-cell" style="text-align: end;">{{ getOverallPercentage() }}</td>

                        <td class="amount-cell" style="text-align: end;">{{ formatCurrency(getTotalRcvAmount()) }}</td>
                        <td class="amount-cell" style="text-align: end;">{{ formatCurrency(getTotalDonationAmount()) }}</td>
                        <td class="amount-cell" style="text-align: end;"><strong>{{ formatCurrency(getTotalEkunJama())
                                }}</strong></td>

                        <td class="amount-cell" style="text-align: end;">{{ formatCurrency(getTotalUnpaidAmount()) }}
                        </td>
                        <td class="amount-cell" style="text-align: end;">{{ formatCurrency(getCTotalUnpaidAmount()) }}
                        </td>
                        <td class="amount-cell" style="text-align: end;"><strong>{{
                                formatCurrency(getGTotalUnpaidAmount()) }}</strong></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>

    <div class="dialog-actions">
        <button mat-raised-button color="primary" (click)="printPageA3Portrait()">Print</button>
        <button mat-raised-button (click)="closeDialog()">बंद करा</button>
    </div>
</div>